<div class="user-panel">
    <div class="user-button-container">
        <dx-drop-down-button
            stylingMode="text"
            [showArrowIcon]="false"
            [items]="isSalesforceAuth ? salesforceMenuItems : menuItems()"
            displayExpr="text"
            itemTemplate="userMenuItem"
            template="template"
            [elementAttr]="{ class: 'menu-button' }"
            [dropDownOptions]="{
                wrapperAttr: { class: 'user-dropdown-wrapper' },
                width: !isSalesforceAuth ? '248px' : 'auto',
                height: 'auto',
            }"
        >
            <div *dxTemplate="let data of 'template'" class="tab">
                @if (avatarUrl$ | async; as avatarUrl) {
                    <div class="avatar-container">
                        <img [src]="avatarUrl" alt="User Avatar" class="user-avatar" />
                    </div>
                } @else {
                    <div class="initials-container">
                        {{ userInitials$ | async }}
                    </div>
                }
            </div>

            @if (isSalesforceAuth) {
                <div *dxTemplate="let item of 'userMenuItem'" class="salesforce-panel">
                    <div class="header">
                        <span class="user-email">{{ (currentUser$ | async)?.email }}</span>
                        <dx-button
                            class="logout"
                            icon="cn-icon-logout "
                            stylingMode="text"
                            [hint]="logoutLabel"
                            [elementAttr]="{ 'aria-label': logoutLabel }"
                            (onClick)="logout($event.event)"
                        ></dx-button>
                    </div>
                    <uxlabs-app-account-switch redirect></uxlabs-app-account-switch>
                </div>
            } @else {
                <a *dxTemplate="let item of 'userMenuItem'" class="dropdown-switcher-item" routerLinkActive="active">
                    @if (item.icon) {
                        <i class="switcher-icon {{ item.icon }}"></i>
                    }
                    <span>{{ item.text }}</span>
                </a>
            }
        </dx-drop-down-button>
    </div>
</div>
